"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const get_1 = __importDefault(require("lodash/get"));
const intl_1 = require("@kyruus/intl");
const ProviderLocations_styles_1 = require("./ProviderLocations.styles");
const util_1 = require("../common/util");
const Location_1 = require("./Location");
const LocationsLink_1 = require("./LocationsLink");
const createTableHeader = (message) => {
    if (message) {
        if (Array.isArray(message)) {
            return (react_1.default.createElement("th", { scope: "col" }, message.map((msg, i) => (react_1.default.createElement(react_1.default.Fragment, { key: msg.id },
                i !== 0 && '/',
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, msg)))))));
        }
        return (react_1.default.createElement("th", { scope: "col" },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, message))));
    }
    // empty <th /> breaks WCAG a11y rules (https://github.com/dequelabs/axe-core/issues/3404#issuecomment-1075282784)
    // so just return null so react renders nothing (no header to render)
    return null;
};
const getPhoneAndOrFaxHeader = (headers) => {
    if (headers.phone && headers.fax) {
        return createTableHeader([util_1.messages.phone, util_1.messages.fax]);
    }
    if (headers.phone) {
        return createTableHeader(util_1.messages.phone);
    }
    if (headers.fax) {
        return createTableHeader(util_1.messages.fax);
    }
    return createTableHeader();
};
const ProviderLocations = ({ config, locations, searchSummary, track, provider, bookOnlineUrl, onClickShowAvailability, availabilityTilesMessages, shouldDisplayAvailability, isAvailabilityReadOnly = false, availabilityLinkTarget, onTimeSlotsClick, onViewMoreClick, onAvailabilityTilesLoaded, apptInfo, slots = [], slotsStatus, getLocationUrl, locationCallback, locationCTA, locationsUrl, locationsCallback, shouldDisplayFaxNumber = false, prioritizeDistance = false, shouldRenderSlotsAsButtons = false, ariaProps, enableLocationsLimit }) => {
    const locationsLimit = (0, get_1.default)(config, 'provider_tile.max_visible_locations', util_1.DEFAULT_PROVIDER_TILE_MAX_LOCATIONS);
    const headers = (0, util_1.getLocationHeadersForProvider)(locations, shouldDisplayFaxNumber);
    const availByLocId = slots.reduce((groupedSlots, slot) => {
        const { location_id } = slot;
        if (groupedSlots[location_id]) {
            groupedSlots[location_id].push(slot);
        }
        else {
            groupedSlots[location_id] = [slot];
        }
        return groupedSlots;
    }, {});
    const locationComponents = (0, util_1.getSortedLocations)(locations, prioritizeDistance)
        .slice(0, enableLocationsLimit ? locationsLimit : locations.length)
        .map((location) => {
        var _a;
        const locationAvail = availByLocId
            ? (_a = availByLocId === null || availByLocId === void 0 ? void 0 : availByLocId[location.id]) !== null && _a !== void 0 ? _a : []
            : null;
        return (react_1.default.createElement(Location_1.Location, { config: config, location: location, headers: headers, searchedLocation: searchSummary.location, track: track, key: `${location.external_id}:${location.id}`, onClickShowAvailability: onClickShowAvailability, availabilityTilesMessages: availabilityTilesMessages, provider: provider, bookOnlineUrl: bookOnlineUrl, shouldDisplayAvailability: shouldDisplayAvailability, isAvailabilityReadOnly: isAvailabilityReadOnly, availabilityLinkTarget: availabilityLinkTarget, onTimeSlotsClick: onTimeSlotsClick, onViewMoreClick: onViewMoreClick, onAvailabilityTilesLoaded: onAvailabilityTilesLoaded, apptInfo: apptInfo, availability: locationAvail, slotsStatus: slotsStatus, getLocationUrl: getLocationUrl, locationCallback: locationCallback, locationCTA: locationCTA, shouldRenderSlotsAsButtons: shouldRenderSlotsAsButtons }));
    });
    return locations.length ? (react_1.default.createElement("div", null,
        react_1.default.createElement(ProviderLocations_styles_1.LocationTable, null,
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    createTableHeader(util_1.messages.location),
                    getPhoneAndOrFaxHeader(headers),
                    locationCTA
                        ? createTableHeader(util_1.messages.action)
                        : createTableHeader())),
            react_1.default.createElement("tbody", null, locationComponents)),
        enableLocationsLimit && locations.length > locationsLimit && (react_1.default.createElement(LocationsLink_1.LocationsLink, { ariaLabeledBy: ariaProps.locationsAriaLabeledBy, href: locationsUrl, onClick: locationsCallback, provider: provider, track: track, locationCount: locations.length - locationsLimit })))) : null;
};
exports.default = ProviderLocations;
//# sourceMappingURL=ProviderLocations.js.map